import dayjs from 'dayjs'

export const basename = path => path.split('/').pop().split('#')[0].split('?')[0]

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes, si=true, dp=1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10**dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


  return bytes.toFixed(dp) + ' ' + units[u];
}

export const formatDate = date => dayjs(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
export const formatDateExt = date => dayjs(date, 'YYYY-MM-DD').format('MMM D, YYYY')

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
export const formatCurrency = (value) => currencyFormatter.format(value)

export const formatPercent = (value, digits = 2) => (value * 100).toFixed(digits) + "%"

export const colorByValue = (value) => {
  if (value > 0.0) {
    return 'green'
  } else if (value < 0.0) {
    return 'red'
  } else {
    return 'gray'
  }
}
